import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Button,
  Divider,
  Grid,
  FormControlLabel,
  Checkbox,
  Switch,
  Radio,
  RadioGroup,
  FormLabel,
  OutlinedInput,
  Chip,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SubscriptionPlanTable from "./SubscriptionPlanTable";
import {
  createPlanRequest,
  fetchPlansRequest,
  updatePlanRequest,
} from "../../../redux/sagas/Subscription/SubscriptionSlice";
import CustomModal from "../../Comman/Modal";
import { toast } from "react-toastify";
import TableCompo from "../Table/TableCompo";
import { RiDeleteBin6Line, RiEdit2Fill } from "react-icons/ri";
import { getBenefitsAndFeatures } from "../../../redux/Configuration/configurationSlice";
import {
  subscriptionFrequency,
  benefitFields,
  featureOptions,
} from "../../../configs/constants";
import { apiRequest } from "../../../redux/Reports/reportsSlice";
import useCsvConverter from "../../../hooks/convertToCSV";
import { canShowPermission } from "../Permissions/permissionObject";
import Reusable from "../Configuration/Reusables";
import { fetchJewellersSidebarRequest } from "../../../redux/JewellerList/JewellerSlice";

const jewellerIdsFrom = (jeweller) => {
  if (!jeweller) return [];
  const list = Array.isArray(jeweller) ? jeweller : [jeweller];
  return list
    .map((item) => {
      if (!item) return "";
      if (typeof item === "object") return String(item._id || item.id || "");
      return String(item);
    })
    .filter(Boolean);
};

const CreateSubscriptionPlan = ({
  onUpdate,
  header,
  selectedRow = null,
  asPage = false,
}) => {
  const dispatch = useDispatch();
  const benefitsData = useSelector(
    (state) => state?.appConfig?.benefitsAndFeatures?.benefitFields || {},
  );
  const featuresData = useSelector(
    (state) => state?.appConfig?.benefitsAndFeatures?.FeatureOptions || {},
  );
  const [featureOptions, setFeatureOptions] = useState(featuresData);
  const { jewellersSidebar = [] } = useSelector((state) => state.jeweller || {});

  const [form, setForm] = useState({
    planName: "",
    validity: "",
    amount: "",
    features: [],
    benefits: benefitsData,
    //   benefits: benefitFields.reduce((acc, curr) => {
    //   acc[curr.key] = { value: "", restricted: false };
    //   return acc;
    // }, {})
    onBoardingPlan: false,
    type: "All",
    jeweller: [],
  });
  //console.log("inside create subscription plan",selectedRow);

  useEffect(() => {
    if (selectedRow) {
      const type = selectedRow.type === "Custom" ? "Custom" : "All";
      setForm({
        ...selectedRow,
        type,
        jeweller: type === "Custom" ? jewellerIdsFrom(selectedRow.jeweller) : [],
      });
    }
  }, [selectedRow]);
  useEffect(() => {
    dispatch(getBenefitsAndFeatures());
    dispatch(fetchJewellersSidebarRequest({ allActive: true }));
  }, [dispatch]);

  useEffect(() => {
    if (!Array.isArray(benefitsData) || benefitsData.length === 0) return;
    setForm((prev) => {
      if (Array.isArray(prev.benefits) && prev.benefits.length > 0) return prev;
      return { ...prev, benefits: benefitsData };
    });
  }, [benefitsData]);

  const handleChange = (key, value) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  const featuresForReusable = (Array.isArray(form.features) ? form.features : []).map(
    (f) => String(f).toLowerCase(),
  );
  // const handleReusableFeatureChange = (lowerCaseArray) => {
  //   const normalized = Object.values(featuresData).filter((feature) =>
  //     lowerCaseArray.includes(feature.toLowerCase()),
  //   );

  //   setForm((prev) => ({
  //     ...prev,
  //     features: normalized,
  //   }));
  // };

  const handleReusableFeatureChange = (selectedValues) => {
    const normalized = Object.values(featuresData).filter((feature) =>
      selectedValues.some((val) => val.toLowerCase() === feature.toLowerCase()),
    );

    setForm((prev) => ({
      ...prev,
      features: normalized,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmedName = form.planName.trim();
    if (!trimmedName) {
      toast.error("Please enter a valid plan name ");
      return;
    }
    if (form.amount <= 0) {
      toast.error("Please enter a valid plan amount ");
      return;
    }

    // checking if plan name, validity or amount is missing
    if (!form.amount || !form.planName || !form.validity) {
      toast.error("please plan name or fill amount or select validity");
      return;
    }
    // checking the restricted value if any
    const benefitList = Array.isArray(form.benefits) ? form.benefits : [];
    let is_missing = benefitList.find(
      (item) =>
        item.restricted && (!Number(item.value) || Number(item.value) <= 0),
    );
    if (!form.amount || form.amount < 0) {
      toast.error("Amount cannot be less than 0");
      return;
    }

    if (is_missing) {
      toast.error("please fill the restricted value or fill correct");
      return;
    }

    const type = form.type === "Custom" ? "Custom" : "All";
    const jeweller = type === "Custom" ? jewellerIdsFrom(form.jeweller) : [];
    if (type === "Custom" && jeweller.length === 0) {
      toast.error("Select at least one jeweller for a custom plan");
      return;
    }

    const payload = {
      ...form,
      planName: trimmedName,
      type,
      jeweller,
    };

    if (selectedRow) {
      dispatch(updatePlanRequest({ ...payload, _id: selectedRow._id }));
    } else {
      dispatch(createPlanRequest(payload));
    }
    onUpdate(false);
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   console.log(form);
  // };

  const sectionSx = {
    background: "#fff",
    borderRadius: 2,
    p: 0,
    mb: 3,
  };

  return (
    <Box
      sx={
        asPage
          ? { width: "100%", background: "transparent" }
          : {
              width: "100%",
              maxWidth: "100%",
              mx: "auto",
              height: "100vh",
              background: "#fff",
              borderRadius: 2,
              overflow: "scroll",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              p: { xs: 2, md: 4 },
            }
      }
    >
      <Typography fontWeight={700} fontSize={asPage ? 28 : 24} mb={0.5} fontFamily="Aeonik">
        {header} Subscription Plan
      </Typography>
      {asPage && (
        <Typography color="text.secondary" mb={3}>
          Set the plan price, who can use it, and the features and benefits included.
        </Typography>
      )}

      <form onSubmit={handleSubmit}>
        <Box sx={asPage ? sectionSx : undefined}>
          {asPage && (
            <Typography fontWeight={700} mb={2}>
              Plan details
            </Typography>
          )}
        <Grid container spacing={asPage ? 2 : 4}>
          {/* Plan Name */}
          <Grid item xs={12} sm={4}>
            <TextField
              variant="outlined"
              fullWidth
              label={
                <>
                  Plan Name <span style={{ color: "red" }}>*</span>
                </>
              }
              value={form.planName}
              onChange={(e) => handleChange("planName", e.target.value)}
            />
          </Grid>

          {/* Validity */}
          <Grid item xs={12} sm={4}>
            <Box sx={{ minWidth: 150 }}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="validity-label">Validity</InputLabel>
                <Select
                  labelId="validity-label"
                  id="validity-select"
                  label="Validity"
                  value={form.validity}
                  onChange={(e) => handleChange("validity", e.target.value)}
                >
                  {Object.values(subscriptionFrequency).map((option) => (
                    <MenuItem key={option} value={option}>
                      {option.charAt(0).toUpperCase() + option.slice(1)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Grid>

          {/* Amount */}
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Amount"
              type="number"
              value={form.amount}
              onChange={(e) => {
                const value = Number(e.target.value);
                if (value >= 0) {
                  handleChange("amount", value);
                }
              }}
              inputProps={{ min: 0 }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={form.onBoardingPlan || false}
                  onChange={(e) =>
                    handleChange("onBoardingPlan", e.target.checked)
                  }
                />
              }
              label="OnBoarding Plan"
            />
          </Grid>
        </Grid>
        <Box sx={{ width: "100%", mt: 2 }}>
            <FormControl component="fieldset">
              <FormLabel>Plan for</FormLabel>
              <RadioGroup
                row
                value={form.type === "Custom" ? "Custom" : "All"}
                onChange={(e) => {
                  const nextType = e.target.value;
                  setForm((prev) => ({
                    ...prev,
                    type: nextType,
                    jeweller:
                      nextType === "Custom" ? jewellerIdsFrom(prev.jeweller) : [],
                  }));
                }}
              >
                <FormControlLabel value="All" control={<Radio />} label="All" />
                <FormControlLabel
                  value="Custom"
                  control={<Radio />}
                  label="Custom"
                />
              </RadioGroup>
            </FormControl>
          {form.type === "Custom" && (
            <Box sx={{ mt: 2, maxWidth: 480 }}>
              <FormControl fullWidth>
                <InputLabel id="plan-jeweller-label">Select Jeweller</InputLabel>
                <Select
                  labelId="plan-jeweller-label"
                  multiple
                  value={jewellerIdsFrom(form.jeweller)}
                  onChange={(e) => {
                    const value = e.target.value;
                    handleChange(
                      "jeweller",
                      (typeof value === "string" ? value.split(",") : value).map(
                        String,
                      ),
                    );
                  }}
                  input={<OutlinedInput label="Select Jeweller" />}
                  renderValue={(selected) => (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {selected.map((value) => {
                        const jeweller = jewellersSidebar.find(
                          (item) => String(item.id) === String(value),
                        );
                        return (
                          <Chip
                            key={value}
                            label={jeweller?.jewellerName || value}
                          />
                        );
                      })}
                    </Box>
                  )}
                >
                  {jewellersSidebar.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      <Checkbox
                        checked={jewellerIdsFrom(form.jeweller).includes(
                          String(item.id),
                        )}
                      />
                      {item.jewellerName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          )}
        </Box>
        </Box>

        {/* Features */}
        {/* <FormControl component="fieldset" fullWidth sx={{ mt: 3 }}>
          <Typography>
            Features <span style={{ color: "red" }}>*</span>
          </Typography>

          <Grid container spacing={3}>
            {Object.values(featuresData).map((feature) => (
              <Grid item xs={12} sm={6} md={2} key={feature}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={form.features.includes(feature)}
                      onChange={(e) => {
                        const newFeatures = e.target.checked
                          ? [...form.features, feature]
                          : form.features.filter((f) => f !== feature);
                        handleChange("features", newFeatures);
                      }}
                      sx={{
                        color: "#7b8499",
                        "&.Mui-checked": {
                          color: "#4caf50",
                        },
                      }}
                    />
                  }
                  label={
                    <Typography
                      variant="body2"
                      fontSize="15px"
                      fontWeight="500"
                      color="#7b8499"
                    >
                      {feature}
                    </Typography>
                  }
                />
              </Grid>
            ))}
          </Grid>
        </FormControl> */}
        <Reusable
          label="Features"
          options={Object.values(featuresData)}
          selected={featuresForReusable}
          onChange={handleReusableFeatureChange}
          showButton={false}
        />

        <Divider sx={{ my: asPage ? 0 : 3 }} />

        {/* Limits */}
        <Box sx={asPage ? sectionSx : { mt: 4 }}>
          <Typography variant={asPage ? "subtitle1" : "h6"} fontWeight={700} gutterBottom>
            Benefits
          </Typography>

          {Array.isArray(form.benefits) &&
            form.benefits.map((field) => (
              <Grid
                container
                mb={2}
                spacing={2}
                sx={{ display: "flex", justifyContent: "space-evenly" }}
                key={field.key}
              >
                <Grid item xs={12} sm={4}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={field.restricted || false}
                        onChange={(e) => {
                          let updatedRestricted = form.benefits?.map((item) => {
                            if (item.key == field.key) {
                              item = {
                                ...item,
                                restricted: e.target.checked,
                              };
                            }
                            return item;
                          });
                          handleChange("benefits", updatedRestricted);
                        }}
                      />
                    }
                    label={field.restricted ? "Restricted" : "Unlimited"}
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label={field.label}
                    type="number"
                    value={field.value}
                    onChange={(e) => {
                      let updatedRestricted = form.benefits?.map((item) => {
                        if (item.key == field.key) {
                          item = { ...item, value: e.target.value };
                        }
                        return item;
                      });
                      handleChange("benefits", updatedRestricted);
                    }}
                    disabled={!field.restricted}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    label={"Description"}
                    type="text"
                    value={field.description}
                    onChange={(e) => {
                      let updatedRestricted = form.benefits?.map((item) => {
                        if (item.key == field.key) {
                          item = { ...item, description: e.target.value };
                        }
                        return item;
                      });
                      handleChange("benefits", updatedRestricted);
                    }}
                  />
                </Grid>
              </Grid>
            ))}
        </Box>

        {/* Button */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1.5,
            mt: 1,
            ...(asPage
              ? {
                  background: "#fff",
                  pt: 2,
                }
              : {}),
          }}
        >
          {asPage && (
            <Button
              variant="outlined"
              onClick={() => onUpdate(false)}
              sx={{ textTransform: "none", px: 3 }}
            >
              Cancel
            </Button>
          )}
          <Button
            variant="contained"
            type="submit"
            sx={{
              background: "#7028DA",
              px: 6,
              textTransform: "none",
            }}
          >
            Save Plan
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export const CreateSubscriptionPlanPage = () => {
  const navigate = useNavigate();
  const goBack = () => navigate("/SubscriptionsPage");

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        background: "#fff",
        pt: { xs: 11, md: 12 },
        pb: 4,
        px: { xs: 2, md: 4 },
      }}
    >
      <Box
        sx={{
          maxWidth: "100%",
          mx: "auto",
          background: "#fff",
          borderRadius: 2,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          p: { xs: 2, md: 4 },
        }}
      >
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={goBack}
          sx={{ mb: 2, textTransform: "none", color: "#5b21b6", fontWeight: 600 }}
        >
          Back to subscription plans
        </Button>
        <CreateSubscriptionPlan onUpdate={goBack} header="Create" asPage />
      </Box>
    </Box>
  );
};

const SubscriptionPlan = () => {
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null);
  const [update, setUpdate] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    console.log(selectedRow);
    if (selectedRow) {
      setUpdate(true);
    }
  }, [selectedRow]);

  useEffect(() => {
    console.log(update);
  }, [update]);

  const { data = [], total = 0 } = useSelector(
    (state) => state.subscriptionPlan || {},
  );
  const dispatch = useDispatch();
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");
    if (storedPermissions) {
      try {
        setPermissions(JSON.parse(storedPermissions));
      } catch (error) {
        console.error("Error parsing stored permissions", error);
      }
    }
  }, []);
  const canCreateSubscription = canShowPermission(
    permissions,
    "subscriptionMain",
    "create",
  );
  const canEditSubscription = canShowPermission(
    permissions,
    "subscriptionMain",
    "edit",
  );

  const handleTableChange = (action, payload) => {
    if (action === "changePage") {
      setPage(payload.page);
    }
    if (action === "changeRowsPerChange") {
      setLimit(payload.rowsPerPage);
      setPage(0);
    }
    if (action === "search") {
      setSearchText(payload.searchText);
      setPage(0);
    }
  };

  const columns = [
    { field: "planName", headerName: "Plan Name" },
    { field: "validity", headerName: "Validity" },
    { field: "amount", headerName: "Amount" },
    { field: "onBoardingPlan", headerName: "OnBoarding Plan" },
    {
      field: "type",
      headerName: "Type",
      render: (_value, row) => (row.type === "Custom" ? "Custom" : "All"),
    },
    // { field: 'scheduleAt', headerName: 'Schedule At',  render: (value, row) => (
    //     <>{moment(row.scheduleAt).format("DD-MM-YYYY hh:mm A")}</>
    //   ) },
    // { field: 'noti', headerName: 'Notification Sent',  render: (value, row) => (
    //    <>{row.isNotificationSent ? "Yes" : "No"}</>
    //   ) },
    {
      field: "action",
      headerName: "Action",
      render: (value, row) => (
        <Box display="flex" alignItems="center">
          {/* Edit Icon */}
          {canEditSubscription && (
            <RiEdit2Fill
              style={{ cursor: "pointer", color: "green", marginRight: 10 }}
              onClick={() => setSelectedRow(row)}
            />
          )}

          {/* Enable/Disable Button */}
          {canEditSubscription && (
            <Switch
              checked={!!row.enabled}
              color="primary"
              onChange={(e) => {
                const type = row.type === "Custom" ? "Custom" : "All";
                dispatch(
                  updatePlanRequest({
                    ...row,
                    enabled: e.target.checked,
                    type,
                    jeweller:
                      type === "Custom" ? jewellerIdsFrom(row.jeweller) : [],
                  }),
                );
              }}
            />
          )}
        </Box>
      ),
    },
  ];

  //   useEffect(() => {
  //   dispatch(fetchPlansRequest());
  // }, [dispatch]);
  useEffect(() => {
    dispatch(
      fetchPlansRequest({ search: searchText, page: page + 1, limit: limit }),
    );
  }, [dispatch, searchText, page, limit]);

  const { convertToCsv } = useCsvConverter();

  const triggerCsvDownload = (csvText, filename) => {
    const blob = new Blob([csvText], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();

    window.URL.revokeObjectURL(url);
  };

  const handleDownloadStoreCsv = () => {
    console.log("Store CSV API called");

    dispatch(
      apiRequest({
        method: "GET",
        endpoint: "/api/v1/subscription/jewellerSubscriptionCsv",
        query: {},
        callback: (response) => {
          const csv = convertToCsv(response?.data || []);
          triggerCsvDownload(csv, "jewellerSubscription.csv");
        },
      }),
    );
  };
  const safeData = Array.isArray(data) ? data : [];
  return (
    <Box sx={{ width: "100%", height: "100vh", overflow: "hidden" }}>
      <Box sx={{ height: "100%", overflowY: "auto", p: 2 }}>
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            mx: "auto",
            mt: { xs: 8, md: 10 },
            background: "#fff",
            borderRadius: 2,
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            p: { xs: 2, md: 4 },
          }}
        >
          <Typography fontWeight={700} fontSize={24} mb={2} fontFamily="Aeonik">
            Subscription Plan's
          </Typography>
          {canCreateSubscription && (
            <Button
              variant="contained"
              onClick={() => navigate("/CreateSubscriptionPlan")}
            >
              Create Plan
            </Button>
          )}
          <CustomModal
            setOpen={setUpdate}
            open={update}
            content={
              <CreateSubscriptionPlan
                onUpdate={setUpdate}
                header={"Update"}
                selectedRow={selectedRow}
              />
            }
          ></CustomModal>

          <TableCompo
            columns={columns}
            data={safeData}
            page={page}
            limit={limit}
            totalCount={total}
            onTableChange={handleTableChange}
            extraButtons={
              <Button
                size="sm"
                variant="outlined"
                onClick={handleDownloadStoreCsv}
              >
                Download CSV
              </Button>
            }
          />
        </Box>
      </Box>
    </Box>
  );
};

export default SubscriptionPlan;
